// Foursquare Places API Configuration
// Get your FREE API key: https://foursquare.com/developers/signup
// 100,000 FREE searches per month - no credit card required!

/**
 * Foursquare API Key
 * 
 * To get your API key:
 * 1. Go to: https://foursquare.com/developers/signup
 * 2. Create a free account
 * 3. Click "Create a New App"
 * 4. Fill in app details:
 *    - App Name: BookAPT
 *    - Website URL: https://bookapt.io (or your domain)
 *    - Description: Appointment booking platform
 * 5. Copy your API key (starts with 'fsq3...')
 * 6. Replace the value below with your actual API key
 * 
 * Free Tier: 100,000 API calls per month
 * No credit card required!
 */
export const FOURSQUARE_API_KEY = '0YTFCWSLYZMPDIKZU02XDIUDX0IRYR5IAX1WGIDPX4M020F5'; // ✅ Service Key configured

/**
 * Validate that API key is configured
 */
export const isFoursquareConfigured = (): boolean => {
  return FOURSQUARE_API_KEY !== 'fsq3YOUR_API_KEY_HERE' && FOURSQUARE_API_KEY.length > 10;
};

/**
 * Get setup instructions
 */
export const getFoursquareSetupInstructions = (): string => {
  return `
🔑 Foursquare API Setup (FREE - 100,000 searches/month!)

1. Go to: https://foursquare.com/developers/signup
2. Create free account (no credit card required)
3. Click "Create a New App"
4. Fill in:
   - App Name: BookAPT
   - Website URL: https://bookapt.io
   - Description: Appointment booking platform
5. Copy your API key (starts with 'fsq3...')
6. Update FOURSQUARE_API_KEY in this file: src/config/foursquareConfig.ts

✅ That's it! You now have 100,000 FREE searches per month!
  `.trim();
};

